export const isAustraliaCombo = item => Number(item?.itemType || 1) === 2
export const australiaCartKey = item => String(item.cartLineKey || item.itemKey || item.dealerItemSkuId || item.id || '')
export const australiaCartQuantity = item => Math.max(1, Number(isAustraliaCombo(item) ? item.comboBuyQty || item.buyAmount || 1 : item.buyAmount || 1))
export const australiaCartTotalUnits = item => isAustraliaCombo(item)
  ? item.selectedSkuList?.length ? item.selectedSkuList.reduce((sum, sku) => sum + Number(sku.buyAmount || 0), 0) : Number(item.comboPackageQty || item.packageQty || 1) * australiaCartQuantity(item)
  : australiaCartQuantity(item)
export function australiaCartMaximum(item) {
  const value = Number(item.comboInventory ?? item.inventory ?? 999)
  const available = Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0
  if (!isAustraliaCombo(item)) return available
  const current = australiaCartQuantity(item)
  const maxima = (item.selectedSkuList || []).filter(sku => sku.inventory != null && Number(sku.buyAmount) > 0).map(sku => Math.floor(Number(sku.inventory) / (Number(sku.buyAmount) / current)))
  return Math.max(0, Math.min(available, ...maxima))
}
export const australiaCartAmount = item => isAustraliaCombo(item) && item.comboAmount != null
  ? Number(item.comboAmount)
  : Number(isAustraliaCombo(item) ? item.comboUnitPrice ?? item.price ?? 0 : item.discountPrice ?? item.price ?? 0) * australiaCartQuantity(item)

// Preserve the customer's flavour mix when changing the number of bundles.
// A mix that cannot be divided into identical bundles needs a fresh selection.
export function resizeAustraliaBundle(item, quantity) {
  if (!Number.isInteger(quantity) || quantity < 1 || quantity > australiaCartMaximum(item)) return null
  const current = australiaCartQuantity(item)
  const list = item.selectedSkuList || []
  if (!list.length || list.some(sku => Number(sku.buyAmount || 0) % current !== 0)) return null
  const next = list.map(sku => ({ ...sku, buyAmount: Number(sku.buyAmount) / current * quantity }))
  if (next.some(sku => sku.inventory != null && sku.buyAmount > Number(sku.inventory))) return null
  const packageQty = Number(item.comboPackageQty ?? item.packageQty ?? list.reduce((sum, sku) => sum + Number(sku.buyAmount || 0), 0) / current)
  if (!Number.isInteger(packageQty) || packageQty < 1) return null
  const required = packageQty * quantity
  return next.reduce((sum, sku) => sum + sku.buyAmount, 0) === required ? next : null
}

export function normalizeAustraliaCartItem(item) {
  const quantity = australiaCartQuantity(item)
  const selected = Array.isArray(item.selectedSkuList) ? item.selectedSkuList : []
  return {
    ...item,
    itemType: Number(item.itemType || 1),
    dealerItemSkuId: item.dealerItemSkuId || item.spItemSkuId || item.offerId || '',
    buyAmount: Number(item.buyAmount || item.comboBuyQty || 1),
    comboBuyQty: Number(item.comboBuyQty || item.buyAmount || 1),
    iconUrl: item.iconUrl || item.image || '',
    selectedSkuList: selected,
    ...(isAustraliaCombo(item) ? {
      comboUnitPrice: item.comboUnitPrice ?? (item.comboAmount != null ? Number(item.comboAmount) / quantity : item.price),
      comboPackageQty: item.comboPackageQty ?? item.packageQty ?? selected.reduce((sum, sku) => sum + Number(sku.buyAmount || 0), 0) / quantity,
    } : {}),
  }
}

export function buildAustraliaCartConfirmation(item) {
  const common = { itemType: Number(item.itemType || 1), dealerShopId: String(item.dealerShopId || ''), countryCode: 'AU' }
  if (isAustraliaCombo(item)) return {
    ...common, comboCode: String(item.comboCode || ''), comboBuyQty: australiaCartQuantity(item), cartLineKey: item.cartLineKey || '',
    selectedSkuList: (item.selectedSkuList || []).map(sku => ({ dealerItemSkuId: String(sku.dealerItemSkuId), buyAmount: Number(sku.buyAmount || 0) })),
  }
  return { ...common, dealerItemSkuId: String(item.dealerItemSkuId || ''), buyAmount: australiaCartQuantity(item), spItemSkuSpecConfig: item.specsInfo || '' }
}
